import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { IDownloadableAsset, IDownloadResult } from '@lassi/webapp-shared';
import { AssetListItemComponent } from './asset-list-item.component';

@Component({
  selector: 'lib-asset-list',
  imports: [AssetListItemComponent],
  template: `
    <p class="mat-title-small">{{ title() }} ({{ assets().length }})</p>
    @for (asset of assets(); track asset.name) {
      <lib-asset-list-item
        [asset]="asset"
        (download)="
          download.emit({
            asset,
            isSuccess: $event,
          })
        "
      />
    } @empty {
      <span class="mat-body-small">
        {{ emptyText() }}
      </span>
    }
  `,
  styles: `
    @use '@angular/material' as mat;
    @use 'theme' as theme;

    :host {
      padding: 1rem;
      background-color: #{mat.get-theme-color(
          theme.$light-theme,
          inverse-on-surface
        )};
      display: block;
      border-radius: 12px;

      p {
        margin: 0;
      }

      lib-asset-list-item {
        margin-top: 0.5rem;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'data-testid': 'assets',
  },
})
export class AssetListComponent {
  assets = input.required<IDownloadableAsset[]>();
  emptyText = input<string>('No assets found');
  title = input<string>('Assets');

  download = output<IDownloadResult>();
}
